import translate from '~/consts/phoneTranslations.js';
import countries from '~/consts/phoneCountries.js';

export default {
    data() {
        return {
            intlinput: null,
            styleLink: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/24.7.0/build/css/intlTelInput.min.css',
            scriptLink: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/24.7.0/build/js/intlTelInput.min.js',
            utilsLink: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/24.7.0/build/js/utils.min.js',
            _countryChangeHandler: null,
            _keydownHandler: null,
        };
    },
    computed: {
        getTypeCountries() {
            const type = this.$store.getters['global/globalSettings']?.additional_settings?.country_code;
            if (type === 'global') {
                return countries.global;
            }
            if (type === 'europe') {
                return countries.europe;
            }
            if (type === 'romania') {
                return countries.romania;
            }
            if (type === 'moldova') {
                return countries.moldova;
            }
            return countries.global;
        },
        formatPhoneNumber() {
            if (this?.intlinput?.getSelectedCountryData()?.dialCode) {
                const type = this.$store.getters['global/globalSettings']?.additional_settings?.country_code;
                const normalizedValue = this?.value?.replace(/[()\-\s]/g, '');
                if (
                    !normalizedValue?.includes(`+${this?.intlinput?.getSelectedCountryData()?.dialCode}`) &&
                    (type === 'romania' || type === 'moldova')
                ) {
                    return '';
                }
                if (this?.value) {
                    if (this?.intlinput?.getSelectedCountryData()?.dialCode) {
                        if (this?.value?.includes(this?.intlinput?.getSelectedCountryData()?.dialCode)) {
                            return this?.value
                                ?.replace(/[()\-\s]/g, '')
                                .replace(`+${this.intlinput.getSelectedCountryData().dialCode}`, '')
                                .replace(/^0+/, '');
                        }

                        this?.intlinput?.setNumber(this?.value);
                        return this?.value
                            ?.replace(/[()\-\s]/g, '')
                            .replace(`+${this.intlinput.getSelectedCountryData().dialCode}`, '')
                            .replace(/^0+/, '');
                    }

                    return this?.value?.replace(/[()\-\s]/g, '') || '';
                } else {
                    return '';
                }
            } else {
                if (this?.value) {
                    if (this?.intlinput?.getSelectedCountryData()?.dialCode) {
                        return this?.value
                            ?.replace(/[()\-\s]/g, '')
                            .replace(`+${this.intlinput.getSelectedCountryData().dialCode}`, '')
                            .replace(/^0+/, '');
                    }

                    return this?.value?.replace(/[()\-\s]/g, '') || '';
                } else {
                    return '';
                }
            }
        },
    },
    methods: {
        update(e) {
            if (this?.intlinput?.getSelectedCountryData()?.dialCode) {
                this.$emit(
                    'get-number-count',
                    this.intlinput.maxCoreNumberLength + `+${this.intlinput.getSelectedCountryData().dialCode}`.length
                );

                if (e.target.value) {
                    this.$emit(
                        'input',
                        `+${this.intlinput.getSelectedCountryData().dialCode}${e.target.value}`.replace(/\s+/g, '')
                    );
                } else {
                    this.$emit('input', '');
                }
            }
        },
        initializeIntlTelInput() {
            const type = this.$store.getters['global/globalSettings']?.additional_settings?.default_country_code;

            if (window.intlTelInput && this.$refs.phoneInput) {
                this.intlinput = window.intlTelInput(this.$refs.phoneInput, {
                    loadUtilsOnInit: this.utilsLink,
                    onlyCountries: this.getTypeCountries,
                    useFullscreenPopup: false,
                    separateDialCode: true,
                    strictMode: true,
                    initialCountry: type ? type : this.getTypeCountries[0],
                    i18n: translate[this.$i18n.locale],
                });

                this.$refs.phoneInput.addEventListener('countrychange', e => {
                    this.$emit('input', `+${this.intlinput.getSelectedCountryData().dialCode}`);
                });
            }

            this._keydownHandler = e => {
                const pos = this.$refs.phoneInput.selectionStart;
                if ((e.key === '0' || e.code === 'Numpad0') && pos === 0) {
                    e.preventDefault();
                }
            };
            this._countryChangeHandler = e => {
                this.$emit('input', `+${this.intlinput.getSelectedCountryData().dialCode}`);
            };

            this.$refs.phoneInput.addEventListener('keydown', this._keydownHandler);
            this.$refs.phoneInput.addEventListener('countrychange', this._countryChangeHandler);
        },
    },
    mounted() {
        this.$nextTick(() => {
            const script = document.createElement('script');
            script.src = this.scriptLink;
            script.onload = () => {
                this.initializeIntlTelInput();
            };
            document.body.appendChild(script);

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = this.styleLink;
            document.head.appendChild(link);
        });
    },
    beforeDestroy() {
        if (this.intlinput) {
            this.intlinput.destroy();
        }

        if (this.$refs.phoneInput) {
            this.$refs.phoneInput.removeEventListener('keydown', this._keydownHandler);
            this.$refs.phoneInput.removeEventListener('countrychange', this._countryChangeHandler);
        }

        const script = document.querySelector(`body script[src="${this.scriptLink}"]`);
        const style = document.querySelector(`head link[href="${this.styleLink}"]`);

        if (script) {
            script?.remove();
        }

        if (style) {
            style?.remove();
        }
    },
};
